import { trackPlatform } from './album-identity.ts';
type QualityTrack = Parameters<typeof trackPlatform>[0];
export const PLATFORM_QUALITIES = {
  tx: [
    { value: 'jymaster', label: '臻品母带' },
    { value: 'lossless', label: 'SQ无损音质' },
    { value: 'exhigh', label: 'HQ高品质' },
    { value: 'standard', label: '标准音质' },
  ],
  wy: [
    { value: 'jyeffect', label: 'Spatial Audio' },
    { value: 'hires', label: 'Hi-Res' },
    { value: 'lossless', label: '无损HQ' },
    { value: 'exhigh', label: '极高HQ' },
    { value: 'standard', label: '标准' },
  ],
};
export function qualityPlatform(value?: QualityTrack | string) { return typeof value === 'string' ? value === 'tx' || value === 'qq' ? 'tx' : 'wy' : value ? trackPlatform(value) || 'wy' : 'wy'; }
export function platformQualityOptions(value?: QualityTrack | string) { return PLATFORM_QUALITIES[qualityPlatform(value)]; }
export function platformQualityLabel(quality: string, value?: QualityTrack | string) {
  const labels = platformQualityOptions(value);
  return labels.find(item => item.value === quality)?.label || ({ hires: 'Hi-Res', flac24bit: '24-bit', atmos: '臻品音质', atmos_plus: '臻品全景声', jymaster: '臻品母带', jyeffect: 'Spatial Audio' } as Record<string, string>)[quality] || quality;
}
// Old per-song preferences remain valid for playback. When opening the editor,
// represent old enhanced tiers by the nearest offered tier on this platform.
export function offeredQuality(quality: string, value?: QualityTrack | string) {
  const aliases: Record<string, string> = { '128k': 'standard', '320k': 'exhigh', flac: 'lossless', master: 'jymaster' };
  if (Object.hasOwn(aliases, quality)) quality = aliases[quality];
  const options = platformQualityOptions(value);
  if (options.some(item => item.value === quality)) return quality;
  if (qualityPlatform(value) === 'tx') return ['hires', 'flac24bit', 'atmos', 'atmos_plus', 'jyeffect'].includes(quality) ? 'lossless' : 'standard';
  return ['atmos', 'atmos_plus', 'jymaster'].includes(quality) ? 'jyeffect' : quality === 'flac24bit' ? 'hires' : 'standard';
}
export function migratePlatformDefaultQualities(value: unknown, legacy: unknown = 'standard'): Record<'tx' | 'wy', string> {
  const saved = value && typeof value === 'object' && !Array.isArray(value) ? value as Record<string, unknown> : {};
  const previous = typeof legacy === 'string' ? legacy : 'standard';
  const read = (platform: 'tx' | 'wy') => !Object.hasOwn(saved, platform) ? offeredQuality(previous, platform)
    : typeof saved[platform] === 'string' && platformQualityOptions(platform).some(item => item.value === saved[platform]) ? saved[platform] as string : 'standard';
  return { tx: read('tx'), wy: read('wy') };
}
